import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { dsColorNew } from "@palette"

// The stored title ("Edit: <name>", "Clone Report: <name>" or none) drives Save, so it is only read here
const describe = title => {
	if (title?.startsWith('Edit:')) return { icon: 'pen', heading: 'Edit report', name: title.slice(5).trim() }
	if (title?.startsWith('Clone Report:')) return { icon: 'clone', heading: 'Clone report', name: title.slice(13).trim() }
	if (title) return { icon: 'file-plus', heading: title, name: '' }
	return { icon: 'file-plus', heading: 'Create report', name: 'New report' }
}


export default function ReportFormHeaderTitle() {
	const { title } = reportFormData.peek()
	const { icon, heading, name } = describe(title)

	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
		<Box sx={{
			width: 38, height: 38, borderRadius: '10px', flexShrink: 0,
			display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
			background: `linear-gradient(135deg, ${dsColorNew.webBlue500}, ${dsColorNew.cyan})`, color: dsColorNew.white,
		}}>
			<IconSeeker icon={icon} sx={{ fontSize: 16 }}/>
		</Box>
		<Box sx={{ minWidth: 0 }}>
			<Typography component="h2" sx={{ fontSize: 16, fontWeight: 600, color: dsColorNew.textTitle, lineHeight: 1.3 }}>{heading}</Typography>
			{!!name && <Typography sx={{ fontSize: 13, color: dsColorNew.textMuted, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</Typography>}
		</Box>
	</Box>
}
